"use client";

import { Children } from "@/types/types";
import { createContext, useContext, useEffect, useState } from "react";
import { BlackOpacityContext } from "./blackOpacityContext";

interface PopupContextProps {
  isPopupOpen: boolean | undefined;
  togglePopup: () => void;
  openPopup: () => void;
  closePopup: () => void;
}

const PopupContextInit = {
  isPopupOpen: false,
  togglePopup: () => {},
  openPopup: () => {},
  closePopup: () => {},
};

interface PopupProviderProps {
  children: Children;
}

export const PopupContext = createContext<PopupContextProps>(PopupContextInit);

function PopupProvider({ children }: PopupProviderProps) {
  const { openBlackOpacity, closeBlackOpacity } =
    useContext(BlackOpacityContext);

  const [isPopupOpen, setPopupOpen] = useState<boolean>(false);

  const openPopup = () => {
    setPopupOpen(true);
  };

  const closePopup = () => {
    setPopupOpen(false);
    localStorage.setItem("popup", "true");
    closeBlackOpacity();
  };

  // useEffect(() => {
  //   setTimeout(() => {
  //     if (!localStorage.getItem("popup")) {
  //       setPopupOpen(true);
  //       openBlackOpacity();
  //     }
  //   }, 3000);
  // }, [openBlackOpacity]);

  return (
    <PopupContext.Provider
      value={{
        isPopupOpen,
        togglePopup: () => setPopupOpen(!isPopupOpen),
        openPopup,
        closePopup,
      }}
    >
      {children}
    </PopupContext.Provider>
  );
}

export default PopupProvider;
